import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../../responsive";

//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
/*


This are the products on the Front page
This styles are connected to the HomeScreen.jsx


*/

const ImgContainer = styled.div`
  margin: 3px;
`;

//
//
const ContainerText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 5px 0 0 0;
  p {
    color: #272727ab;
    text-transform: lowercase;
  }
  span {
    color: #272727ab;
  }
`;

//
//
const ImgBox = styled.div`
    width: 100%;
   overflow: hidden;
   position: relative;

   //
   img{
  //will make the img square
  aspect-ratio: 1 / 1;
  /* aspect-ratio: 16 / 9; */
  width: 100%;
  min-height: auto;
  object-fit: cover;
  /* border-radius: 25rem;   */
 
  ${mobile({ borderRadius: "0" })}
  ${mobileM({ borderRadius: "0" })}
  ${tablet({ borderRadius: "0" })}

}
  

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;

    filter: contrast(170%) brightness(450%);
    background: linear-gradient(0deg, rgb(250, 200, 62), rgba(252, 255, 233, 0)),
      /* url(../../img/noise.png); */
    opacity: 0.2;
    pointer-events: none;
  }
`;

const AllImgFurniture = ({ product }) => {
  //
  //

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  return (
    <ImgContainer>
      <Link to={`/product/${product._id}`}>
        <ImgBox>
          {" "}
          <motion.img
            data-aos="fade-up"
            whileHover={{ scale: 1.1 }}
            onHoverStart={(eImg) => {}}
            onHoverEnd={(eImg) => {}}
            src={product.image}
          />
        </ImgBox>
      </Link>
      <ContainerText>
        {" "}
        <p>{product.name}</p>
        <span>{product.price} &#8364;</span>
      </ContainerText>
    </ImgContainer>
  );
};

export default AllImgFurniture;
